/**
 * * Модель запроса для перемещения очереди задач
 */
export default class MoveQueueTaskRequest  {
	/**
	 * * Номер группы
	 */
	QueueTaskId!: string;
	/**
	 * * Номер родительской рабочей области если очередь нужно прекрепить к нему
	 */
	ParentNamespaceId?: string;
	/**
	 * * Номер родительской группы если очередь нужно крепить к группе
	 */
	ParentGroupId?: number;
	constructor(obj?: Partial<MoveQueueTaskRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
